import React from "react";
import TradeTable from "../components/TradeTable";


export default () => (
  <div className={"page page-trades"}>
    <TradeTable/>
  </div>
)




